export default __webpack_public_path__ + "static/media/loginLeftImg.549e4675.svg";